import type Performer from "parog-web/models/performer";
import { performerRetrieve } from "parog-web/utils/dmp-utils";
import type { Execution, Section } from "./abstract-dmp-parser";
import AbstractDmpParser from "./abstract-dmp-parser";

interface MedicalImagingExecution extends Execution {
  performer: Performer;
}

export default class MedicalImagingDmpParser extends AbstractDmpParser {
  journalEventClassName = "MedicalImagingRefundedJournalEvent";

  canParse(section: Section): boolean {
    const code = section.code?._attributes?.code;
    const title = section.title?._text;
    return code == "29554-3" && title == "Radiologie";
  }

  parse(section: Section): Array<MedicalImagingExecution> {
    return this.getEntries(section)
      .map(entry => {
        const procedure = entry.procedure;
        if (!procedure) return;

        const source = procedure.code?._attributes;

        if (source.nullFlavor || source.codeSystem == "1.2.250.1.213.2.63")
          return;

        const procedureSourceConcept =
          source.codeSystem == "1.2.250.1.215.200.3.3" ? "NGAP" : "CCAM";

        const procedureSourceValue = source.code;
        const procedureSourceLabel = source.displayName;
        const occurredAt = this.parseOccurredAt(procedure);

        if (
          occurredAt &&
          procedureSourceConcept &&
          procedureSourceValue &&
          procedureSourceLabel
        ) {
          return {
            occurredAt,
            procedureSourceConcept,
            procedureSourceValue,
            procedureSourceLabel,
            performer: performerRetrieve(entry.procedure?.performer)
          };
        }

        return undefined;
      })
      .filter(Boolean) as MedicalImagingExecution[];
  }
}
